exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-props[data-v-3e3afc07]:not(:last-child):after {\n  content: \", \";\n}\n.list-props[data-v-3e3afc07]:last-child:after {\n  content: \".\";\n}", ""]);

// exports
